
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../../../core/modules/shared.module';

import { MapaModule } from './../../components/mapa/mapa.module';
import { StatsModule } from '../stats/stats.module';
import { FiltersModule } from '../filters/filters.module';

import { FusePortfolioComponent } from './portfolio.component';

const routes: Routes = [
    {
        path     : 'portfolio',
        component: FusePortfolioComponent,
        // canActivate: [AuthenticationGuard],
        // runGuardsAndResolvers: 'always',
    }
];

@NgModule({
    declarations: [
        FusePortfolioComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes),
        MapaModule,
        StatsModule,
        FiltersModule
    ],
    exports     : [FusePortfolioComponent]
})

export class FusePortfolioModule
{
}



// WEBPACK FOOTER //
// ./src/app/main/content/portfolio/portfolio.module.ts